import { useRouter } from "next/router";
import { getFigure } from "../figures";
import { O, pipe } from "../prelude";
import { aliasFromRouter, type RAlias } from "../routes";

export function useActiveAlias(): RAlias {
  const { pathname, query } = useRouter();
  let alias = aliasFromRouter({ pathname, query });
  if (alias === "embed" || alias === "figure" || alias === "figures") {
    alias = pipe(
      O.fromNullable(query.id as string | undefined),
      O.chain((id) => getFigure(id)),
      O.map((x) => x.theme),
      O.getOrElse(() => alias),
    );
  }
  return alias;
}
